const validate = (values) => {
  const errors = {};
  if (!values.category) {
    errors.category = 'Esse campo não pode ficar vazio';
  }
  if (!values.description) {
    errors.description = 'Esse campo não pode ficar vazio';
  }
  if (!values.account) {
    errors.account = 'Esse campo não pode ficar vazio';
  }
  if (!values.value) {
    errors.value = 'Esse campo não pode ficar vazio';
  }
  if (values.account && values.account.smartpay && values.value < 10) {
    errors.value =
      'Não é possível gerar cobrança para títulos com valor inferior à R$10,00.';
  }
  if (!values.student) {
    errors.student = 'Esse campo não pode ficar vazio';
  }
  if (!values.responsible) {
    errors.responsible = 'Esse campo não pode ficar vazio';
  }
  if (values.indRepeat) {
    if (!values.paymentFrequency) {
      errors.paymentFrequency = 'Esse campo não pode ficar vazio';
    }
    if (!values.nupaTitu) {
      errors.nupaTitu = 'Esse campo não pode ficar vazio';
    } else if (Number(values.nupaTitu <= 0)) {
      errors.nupaTitu = 'Informe um valor maior que 0';
    }
  }
  return errors;
};
export default validate;
